import { useRef, useState } from "react";
import type { TransferMatchModalContextType } from "../transactions/views/TransferMatchModalContext";
import { TransactionView } from "../../common/types/views/transactionViews";
import {
    StandardModal,
    StandardModalBody,
    StandardModalHeader,
    StandardModalProps,
} from "../general/Modal/Modal";
import { PaginatedTransactionsTableContextProvider } from "../transactions/PaginatedTransactionsTableContextProvider";
import { TransactionsView } from "../transactions/views/TransactionsView";
import { TransactionDetailsContainer } from "../transactions/TransactionDetails/TransactionDetailsContainer";
import { TransactionListItemDto } from "../../common/types/transaction";
import { TransactionSplitModal } from "../transactions/TransactionSplitV2/TransactionSplitModal";
import {
    TransferMatchModalProvider,
    TransferMatchModalContext,
} from "../transactions/views/TransferMatchModalContext";
import styles from "./ActionsTransactionsViewModal.module.scss";

interface ActionTransactionViewModalProps extends StandardModalProps {
    title: string;
    view: TransactionView;
}

export const ActionTransactionViewModal: React.FC<
    ActionTransactionViewModalProps
> = ({ title, view, ...props }) => {
    const scrollContainerRef = useRef<HTMLDivElement>(null);
    const [page, setPage] = useState(1);
    const [selectedTransactionId, setSelectedTransactionId] =
        useState<number>();
    const [openedTransactionForSplit, setOpenedTransactionForSplit] =
        useState<TransactionListItemDto>();

    return (
        <>
            <StandardModal {...props}>
                <StandardModalHeader>{title}</StandardModalHeader>
                <StandardModalBody
                    className={styles.modalBody}
                    ref={scrollContainerRef}
                >
                    <TransferMatchModalProvider>
                        <TransferMatchModalContext.Consumer>
                            {(
                                value:
                                    | TransferMatchModalContextType
                                    | undefined,
                            ) => {
                                if (!value) {
                                    return null;
                                }
                                const { openTransferMatch } = value;
                                return (
                                    <PaginatedTransactionsTableContextProvider
                                        parentFilters={view.filters}
                                        page={page}
                                        setPage={setPage}
                                        useCache={false}
                                    >
                                        <TransactionsView
                                            view={view}
                                            scrollContainerRef={
                                                scrollContainerRef
                                            }
                                            stickyFooter={false}
                                            selectedTransactionId={
                                                selectedTransactionId
                                            }
                                            setSelectedTransactionId={(id) =>
                                                setSelectedTransactionId(
                                                    id as number,
                                                )
                                            }
                                            autoSelect
                                        />

                                        {selectedTransactionId && (
                                            <TransactionDetailsContainer
                                                id={selectedTransactionId}
                                                onSplit={(transaction) => {
                                                    setOpenedTransactionForSplit(
                                                        transaction,
                                                    );
                                                }}
                                                onMatch={(transaction) => {
                                                    openTransferMatch(
                                                        transaction,
                                                    );
                                                }}
                                                onClose={() =>
                                                    setSelectedTransactionId(
                                                        undefined,
                                                    )
                                                }
                                                hideHistory
                                                hideDetails
                                                hideCloseButton
                                            />
                                        )}
                                    </PaginatedTransactionsTableContextProvider>
                                );
                            }}
                        </TransferMatchModalContext.Consumer>
                    </TransferMatchModalProvider>
                </StandardModalBody>
            </StandardModal>

            <TransactionSplitModal
                transaction={openedTransactionForSplit}
                setTransaction={setOpenedTransactionForSplit}
            />
        </>
    );
};
